import { H2 } from '../../../../_components/H2'

import type { IReviewProps } from '../../../_types/review'

import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'

export const ReviewHowTo: React.FC<{
  howTo: IReviewProps['howTo']
}> = ({ howTo }) => {
  if (!howTo) return null
  return (
    <div className='mx-auto max-w-[1220px] px-4'>
      <H2 className='md:text-4XL'>{howTo.title}</H2>
      <div className='flex flex-col items-stretch gap-3 pt-4 md:flex-row md:gap-6 md:pt-9'>
        {howTo.list.map((item, index) => {
          return (
            <div
              key={item.subTitle}
              className='bg-f-bg-container border-f-border rounded-3xl border p-4 md:max-w-[380px] md:p-6'
            >
              <span className='text-f-primary text-2xl font-thin md:text-[56px] md:leading-snug'>
                0{index + 1}
              </span>
              {item.subTitle ? (
                <p className='pt-2 text-lg font-semibold md:text-xl'>
                  {item.subTitle}
                </p>
              ) : null}
              <RichTextElement
                as='p'
                html={item.subDesc}
                className='text-f-other-10 pt-2 text-sm md:text-base'
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
